var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseline-layout',[_c('template',{slot:"pageTitle"},[_c('h2',[_vm._v("Create New Client")])]),_c('v-container',{attrs:{"slot":"main"},slot:"main"},[_c('clients-sidebar'),_c('v-row',[_c('NewClientForm')],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }